import type { VehicleData, FaultData } from './api/types';
import { getMeasurementUnit } from './utils/units';

export const availableFields: Record<string, { label: string; default: boolean }> = {
  speed:             { label: 'Speed',           default: true },
  engine:            { label: 'Engine Status',   default: true },
  faults:            { label: 'Vehicle Faults',  default: true },
  type:              { label: 'Device Type',     default: true },
  odometer:          { label: 'Odometer',        default: true },
  fuelLevel:         { label: 'Fuel Level',      default: true },
  driver:            { label: 'Assigned Driver', default: true },
  group:             { label: 'Group/Division',  default: true },
  vin:               { label: 'VIN',             default: true },
  battery:           { label: 'Battery Voltage', default: true },
  lastCommunication: { label: 'Last Seen',       default: true },
  serialNumber:      { label: 'Serial Number',   default: true },
};

function loadVisibleFields(): string[] {
  const stored = localStorage.getItem('visibleFields');
  if (stored) {
    try { return JSON.parse(stored) as string[]; } catch { /* fall through */ }
  }
  return Object.keys(availableFields).filter((k) => availableFields[k].default);
}

export const state = {
  allVehicles:             [] as VehicleData[],
  currentFilteredVehicles: [] as VehicleData[],
  selectedVehicleId:       null as string | null,
  dataVersion:             0,
  refreshInterval:         null as ReturnType<typeof setInterval> | null,
  lastRefreshTime:         null as Date | null,
  silentRefreshing:        false,
  filters: {
    search: '',
    status: [] as string[],
    engine: [] as string[],
  },
  odometerUnit: getMeasurementUnit(),
  visibleFields: loadVisibleFields(),
  currentFaultVehicle: null as VehicleData | null,
  activeFaultFilter:  'all' as 'all' | 'vehicle' | 'telematics',
  currentDatabase:    '',
  // Bumped on every logout. In-flight fetches capture this before awaiting and check it after —
  // a mismatch means the user logged out/into a different database while the fetch was pending,
  // so the result is discarded instead of overwriting the new session's data.
  sessionEpoch:       0,
};

export function saveVisibleFields(): void {
  localStorage.setItem('visibleFields', JSON.stringify(state.visibleFields));
}

// Dummy export to use the FaultData type (avoids unused import warning)
export type { FaultData };
